// FullCalendar
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import frLocale from '@fullcalendar/core/locales/fr';

window.AgendaCalendarBundle = function (options) {
	const settings = $.extend(true, {
		events: {},
	}, options);

	const agenda = new Agenda();

	//=======================================================
	//======================= CALENDAR ======================

	function Agenda () {
		let _calendarEl,
			_calendar;

		function _init () {
			_calendarEl = document.getElementById('calendar');

			_initFullCalendar();

			_onClickClosePopover();
		}

		/**
		 * Init FullCalendar
		 *
		 * @private
		 */
		function _initFullCalendar () {
			_calendar = new Calendar(_calendarEl, {
				locale: frLocale,
				header: {
					left: 'prev,next today',
					center: 'title',
					right: 'dayGridMonth,dayGridWeek,dayGridDay',
				},
				height: 'parent',
				selectable: false,
				displayEventEnd: true,
				plugins: [dayGridPlugin, interactionPlugin],
				events: settings.events,
				eventRender: _fcEventRender,
				eventClick: _fcOnEventClick,
				viewSkeletonRender:function(info){
					$(info.el).parents('.fc')
						.find('.fc-today-button').html(`<i class="fas fa-calendar fa-fw d-inline d-md-none"></i> ${frLocale.buttonText.today}`).end()
						.find('.fc-dayGridMonth-button').html(`<span class="d-none d-md-inline">${frLocale.buttonText.month}</span><i class="fas fa-calendar-alt d-inline d-md-none"></i>`).end()
						.find('.fc-dayGridWeek-button').html(`<span class="d-none d-md-inline">${frLocale.buttonText.week}</span><i class="fas fa-calendar-week d-inline d-md-none"></i>`).end()
						.find('.fc-dayGridDay-button').html(`<span class="d-none d-md-inline">${frLocale.buttonText.day}</span><i class="fas fa-calendar-day d-inline d-md-none"></i>`).end()
					;
				}
			});

			_calendar.render();
		}

		/**
		 * Au rendu d'un event
		 * Ajouter une popover au click pour afficher les infos de l'évènement
		 *
		 * @param el
		 * @param event
		 *
		 * @private
		 */
		function _fcEventRender ({ el, event }) {
			$(el).popover({
				title: event.title,
				content: `<p>${event.extendedProps.description || ''}</p>`,
				html: true,
				placement: 'top',
				template: `<div class="popover fc-bs-popover" role="tooltip"><div class="arrow"></div><i class="fal fa-times fc-bs-popover-close"></i><h3 class="popover-header"></h3><div class="popover-body"></div></div>`,
			});
		}

		/**
		 * Au clic sur un event du calendrier, cacher les autres popover ouvertes
		 *
		 * @param el
		 * @param event
		 *
		 * @private
		 */
		function _fcOnEventClick ({ el, event }) {
			$('.fc-event').not(el).popover('hide');
		}

		/**
		 * Au clique sur le bouton de fermeture fermer une popover
		 *
		 * @private
		 */
		function _onClickClosePopover () {
			$('body').on('click', '.fc-bs-popover-close', function () {
				$(this).parent().popover('hide');
			})
		}

		_init();
	}
};
